exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.manual-input .text {\n    position: relative;\n}\n.manual-input .fa-trash {\n    cursor: pointer;\n    position: absolute;\n    top: .25rem;\n    right: -1.25rem;\n}\n", ""]);

// exports
